import Select from '@mui/material/Select';

import { styled } from 'helpers';

import { SelectProps } from './Select.types';

export const StyledPlaceholder = styled('span')`
  color: ${({ theme }) => theme.palette.blueGrey['A300']};
  list-style: none;
`;

export const SelectStyled = styled(Select)<SelectProps>`
  padding: 0px;
  background-color: ${({ theme }) => theme.palette.common['white']};

  & .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input {
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    font-weight: ${({ theme }) => theme.typography.body1};
    color: ${({ theme }) => theme.palette.blueGrey['900']};
    line-height: 1.5;
    padding: 8px 42px 8px 16px;
  }
  & .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.palette.blueGrey['A200']};
  }
  &.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.palette.blueGrey['A200']};
  }
  &.Mui-error:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.palette.deepOrange['900']};
  }
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.palette.blue['800']};
    border-width: 1px;
  }
  &.Mui-disabled {
    color: ${({ theme }) => theme.palette.blueGrey['A600']};
    background-color: ${({ theme }) => theme.palette.grey['A100']};
    & .Mui-disabled {
      -webkit-text-fill-color: ${({ theme }) => theme.palette.blueGrey['A600']};
    }
    & li {
      color: ${({ theme }) => theme.palette.blueGrey['A600']};
    }
  }
  & .MuiSelect-icon {
    color: ${({ theme }) => theme.palette.blueGrey['A400']};
    &.Mui-disabled {
      color: ${({ theme }) => theme.palette.blueGrey['A300']};
    }
  }
  & .MuiSelect-iconOpen {
    transform: rotate(0deg);
  }
`;

SelectStyled.displayName = 'Select';
